import { RESET_STATE } from '../types/global';
import {
  // eslint-disable-next-line max-len
  GET_USERS, GET_NEWUSER_APPLICANTS, RESET_NEWUSER_APPLICANTS, RESET_USERS, GET_USER_PROFILE, RESET_USER_PROFILE, DELETE__USER_PROFILE, EDIT_USER_PROFILE, GET_USER_STATUS, GET_USER_ROLES, ADD_USER, RESET_USER_ROLES, RESET_USER_STATUS
} from '../types/user';

export interface UserState {
  getUsers: any,
  userProfile: any,
  userProfileDeleted: boolean,
  userProfileEdited: boolean,
  userRoles: string[],
  userStatuses: any,
  userAdded: any,
  newUserApplicants: any,
}

const INITIAL_STATE: UserState = {
  getUsers: null,
  userProfile: null,
  userProfileDeleted: null,
  userProfileEdited: null,
  userRoles: null,
  userStatuses: null,
  userAdded: null,
  newUserApplicants: null
};

const userReducer = function (state: UserState = INITIAL_STATE, action): UserState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;
    case GET_USERS:
      return { ...state, getUsers: action.payload };

    case RESET_USER_PROFILE:
      return { ...state, userProfile: null };
    case RESET_USERS:
      return { ...state, getUsers: null };

    case GET_USER_PROFILE:
      return { ...state, userProfile: action.payload };

    case DELETE__USER_PROFILE:
      return { ...state, userProfileDeleted: action.payload };

    case EDIT_USER_PROFILE:
      return { ...state, userProfileEdited: action.payload };

    case ADD_USER:
      return { ...state, userAdded: action.payload };

    case GET_USER_STATUS:
      return { ...state, userStatuses: action.payload.map((e) => ({ id: e.statusId, name: e.statusName })) };

    case GET_USER_ROLES:
      return {
        ...state,
        userRoles: action.payload.map((e) => ({ id: e.roleId, name: e.roleName, type: e.userTypeId }))
      };

    case RESET_USER_ROLES:
      return { ...state, userRoles: null };

    case RESET_USER_STATUS:
      return { ...state, userStatuses: null };

    case GET_NEWUSER_APPLICANTS:
      return { ...state, newUserApplicants: action.payload };

    case RESET_NEWUSER_APPLICANTS:
      return { ...state, newUserApplicants: null };
    default:
      return state;
  }
};

export default userReducer;
